import React from 'react';
export var browserDefaultContextDefault = {
  useBrowserDefaultFocusStyle: false
};
var BrowserDefaultFocusStyleContext = /*#__PURE__*/React.createContext(browserDefaultContextDefault);
BrowserDefaultFocusStyleContext.displayName = 'BrowserDefault';
export { BrowserDefaultFocusStyleContext };